module.exports = __webpack_public_path__ + "static/img/4.4ff841f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/eng/4.png
// module id = YdvB
// module chunks = 0